import {Component, OnInit,AfterViewInit,ViewChild,NgZone} from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import {trigger, state, style, animate, transition} from '@angular/animations';
import {AppService} from '../../app.service';
import {AuthenticationService} from '../../services/authentication.service';
import { VersionCheckService } from '../../services/version-check.service';
import { JwtHelperService } from "@auth0/angular-jwt";
import { SignImageService} from '../../services/sign-image.service';
import { TokenStorageService} from '../../services/token-storage.service';
import { HtmlParser } from '@angular/compiler';
import { ToastrService } from 'ngx-toastr';
const helper = new JwtHelperService();
import { ConstantConfigService } from '../../services/constant-config.service';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { UserIdleService } from 'angular-user-idle';
import {GeneralService} from '../../services/general.service';
import { EncrDecrServiceService } from '../../services/encr-decr-service.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
    selector: 'app-sidebar',
    templateUrl: 'sidebar.component.html',
    styleUrls: ['sidebar.component.scss'],
    host: {
        'class': 'sidebar'
    },
    animations: [
        trigger('toggleSubMenu', [
            state('inactive', style({
                height: '0',
                opacity: '0'
            })),
            state('active', style({
                height: '*',
                opacity: '1'
            })),
            transition('inactive => active', animate('200ms ease-in')),
            transition('active => inactive', animate('200ms ease-out'))
        ]),
        trigger('toggleMenuSubMenu', [
            state('inactive', style({
                height: '0',
                opacity: '0'
            })),
            state('active', style({
                height: '*',
                opacity: '1'
            })),
            transition('inactive => active', animate('200ms ease-in')),
            transition('active => inactive', animate('200ms ease-out'))
        ]),
    ]
})
export class SidebarComponent implements OnInit,AfterViewInit {
    @ViewChild('sidebarScrollbar', { static: false }) sidebarScrollbar: NgScrollbar;
    ngAfterViewInit() {
        this.sidebarScrollbar.scrolled.subscribe(e => {
          this.ngZone.run(() => {
            //console.log("target",e);
            this.scrollTop = (<Element>event.target).scrollTop;
            //console.log("scrollTop Pic ", this.scrollTop);
          });
        })
      }
    /* Main Menu

     * title: Main menu title
     * icon: Menu icon from material-design-iconic-fonts. Please refer 'Icons' page for more details
     * route: Router link for page
     * sub: Sub menus
     * visibility: Property for animation. 'inactive' means the sub menu is hidden by default.

     */
    scrollTop:any= 0;
    decodedToken: any = {};
  _accessToken: string = "";
    mainMenu: Array<any> = [
        {
            title: 'My Requests',
            icon: 'view-list',
            show : [
                {
                    type : 2
                },
                {
                    type : 1
                }
                ,
                {
                    type : 0
                }
            ],
            sub: [
                {
                    title: 'Request Listing',
                    route: '/overview',
                    icon:'view-list',
                    role : [
                        {
                            type : 1
                        },
                        {
                            type : 2
                        },
                        {
                            type : 3
                        },
                        {
                            type : 4
                        },
                        {
                            type : 5
                        },
                        {
                            type : 6
                        },
                        {
                            type : 7
                        },

                        {
                            type : 8
                        }
                    ],
                },
                {
                  title: 'Dealhub Renewals',
                  route: '/deal-listing',
                  icon:'view-list',
                  role : [
                      {
                          type : 4
                      },
                      {
                          type : 5
                      },
                      {
                         type : 6
                      },
                      {
                        type : 7
                      }
                  ],
                },
                {
                    title: 'Send',
                    route: '/send-request',
                    icon:'mail-send',
                    data:'ttttt',
                    role:[
                        {
                            type: 4
                        },
                        {
                            type :5
                        },
                        {
                          type : 6
                        },
                        {
                          type : 7
                        },
                        {
                            type : 8
                        }
                    ]
                },
                // {
                //     title: 'Send Watermark Doc',
                //     route: '/send-watermark-doc',
                //     icon:'mail-send',
                //     data:'ttttt',
                //     role:[
                //         {
                //             type: 4
                //         },
                //         {
                //             type :5
                //         },
                //         {
                //             type : 8
                //         }
                //     ]
                // },
                // {
                //     title: 'Track Docs',
                //     route: '/upload-listing',
                //     icon:'view-list',
                //     role : [
                //         {
                //             type : 4
                //         },
                //         {
                //             type : 5
                //         },
                //         {
                //            type : 6
                //         },
                //         {
                //           type : 7
                //         }
                //     ],
                //   },
                // {
                //     title: 'Request Doc Review',
                //     route: '/send-request',
                //     icon:'mail-send',
                //     role:[
                //         {
                //             type: 4
                //         },
                //         {
                //             type :5
                //         }
                //     ]
                // },
                // {
                //     title: 'Request Document',
                //     route: '/send-request',
                //     icon:'mail-send',
                //     role:[
                //         {
                //             type: 4
                //         },
                //         {
                //             type :5
                //         }
                //     ]
                // }
            ],
            visibility: 'inactive'
        },
        {
            title: 'My Docs',
            icon: 'format-list-bulleted',

            role :[
                {
                    type : 1
                },
                {
                    type : 2
                },
                {
                    type : 3
                },
                {
                    type : 4
                },
                {
                    type : 5
                },
                {
                    type : 6
                }
            ],
            sub: [
                {
                    title: 'Templates',
                    icon:'circle-o',
                    route: '/template',
                    show : [
                        {
                            type : 1
                        },
                        {
                            type : 0
                        }
                    ],
                },
                {
                    title: 'Dockits',
                    icon:'circle-o',
                    route: '/kit',
                    show : [
                        {
                            type : 1
                        }
                    ],
                },
                {
                    title: 'Create Doc Slot',
                    icon: 'circle-o',
                    route: '/company-doc-group',
                    role:[
                        {
                            type : 4
                        },
                        {
                            type : 5
                        }
                    ]
                },
            ],
            visibility: 'inactive'
        },
        {
            title: 'Settings',
            icon: 'settings',
            show : [
                {
                    type : 2
                }
            ],
            sub: [
                {
                    title: 'General',
                    route: '/settings',
                    icon: 'settings',
                    role : [
                        {
                            type : 1
                        },
                        {
                            type : 2
                        },
                        {
                            type : 4
                        },
                        {
                            type : 8
                        }
                    ],
                },
                {
                  title: 'Plans',
                  icon: 'grid',
                  route: '/plans',
                  role : [
                    {
                      type : 4
                    },
		    {
                      type : 5
                    },
		    {
                      type : 6
                    },
                    // {
                    //   type : 8
                    // }
                  ]
                },
                // {
                //     title: 'Payments',
                //     icon :'money-box',
                //     subMenu : [
                //         {
                //             title : 'Bank Account/CC',
                //             route : '/home',
                //             icon:'accounts-add'
                //         }
                //     ],
                //     subMenuVisibility: 'inactive'
                // },
                {
                    title: 'Logs',
                    icon:'view-list',
                    route: '/activity-log',
                    /*subMenu : [
                        {
                            title : 'Activity',
                            route : '/activity-log',
                            icon:'circle-o'
                        },
                        {
                            title : 'Request',
                            route : '/request-log',
                            icon:'circle-o'
                        },
                        {
                          title : 'PostMapping',
                          route : '/postmapping-logs',
                          icon:'circle-o'
                       },
                        {
                            title : 'Storage',
                            route : '/storage-log',
                            icon:'circle-o'
                        }
                    ],*/
                    role:[
                        {
                            type : 4
                        },
                        {
                            type : 5
                        }
                    ],
                    subMenuVisibility: 'inactive'
                },
            ],
            visibility: 'inactive'
        },

        {
            title: 'Settings',
            icon: 'settings',
            show : [

                {
                    type : 0
                }
            ],
            sub: [
                {
                    title: 'General',
                    route: '/settings',
                    icon: 'settings',
                    role : [
                        {
                            type : 1
                        },
                        {
                            type : 2
                        },
                        {
                            type : 4
                        },
                        {
                            type : 8
                        }
                    ],
                },
                {
                    title: 'Client Session',
                    route: '/client-session',
                    icon:'accounts-alt',
                    role : [
                        {
                            type : 1
                        },
                        {
                            type : 2
                        },
                    ],
                },

                {
                    title: 'Manage Company',
                    route: '/manage-company',
                    icon:'accounts-alt',
                    role : [
                        {
                            type : 1
                        },
                        {
                            type : 3
                        },
                    ],
                },
                // {
                //     title: 'Manage Company Plan',
                //     route: '/manage-company-plan',
                //     icon:'accounts-alt',
                //     role : [
                //         {
                //             type : 1
                //         },
                //         {
                //             type : 3
                //         },
                //     ],
                // },
                /*{
                    title: 'Company Access Limit',
                    route: '/company-access-limit',
                    icon:'circle-o',
                    role : [
                        {
                            type : 1
                        },
                        {
                            type : 2
                        },
                    ],
                },*/
                /*{
                    title: 'Invite Company',
                    route: '/invite-company',
                    icon:'circle-o',
                    role : [
                        {
                            type : 1
                        },
                    ],
                },*/
                {
                    title: 'Role Privilege',
                    route: '/assign-role',
                    icon:'circle-o',
                    role : [
                        {
                            type : 1
                        },
                    ],
                },
                {
                    title: 'Features',
                    route: '/feature',
                    icon:'circle-o',
                    role : [
                        {
                            type : 1
                        },
                    ],
                },
                // {
                //     title: 'Manage Business Plan',
                //     route: '/send-request',
                //     icon:'circle-o'
                // },
                // {
                //     title: 'Manage Credit Plan',
                //     route: '/send-request',
                //     icon:'circle-o'
                // },
                // {
                //     title: 'Payments',
                //     icon :'money-box',
                //     subMenu : [
                //         {
                //             title : 'Bank Account/CC',
                //             route : '/home',
                //             icon:'accounts-add'
                //         }
                //     ],
                //     subMenuVisibility: 'inactive'
                // },
                // {
                //     title: 'Default Gateway',
                //     route: '/default-gateway',
                //     icon:'grid',
                //     role : [
                //         {
                //             type : 1
                //         },
                //     ],
                // },
                // {
                //     title: 'Queue Monitoring',
                //     route: '/queue-monitoring',
                //     icon:'chart',
                //     role : [
                //         {
                //             type : 1
                //         },
                //     ],
                // },
                {
                    title: 'Logs',
                    icon:'view-list',
                    route: '/activity-log',
                    /*subMenu : [
                        {
                            title : 'Activity',
                            route : '/activity-log',
                            icon:'circle-o'
                        },
                        {
                            title : 'Request',
                            route : '/request-log',
                            icon:'circle-o'
                        },
                        {
                          title : 'PostMapping',
                          route : '/postmapping-logs',
                          icon:'circle-o'
                       },
                        {
                            title : 'Storage',
                            route : '/storage-log',
                            icon:'circle-o'
                        },
                    ],*/
                    subMenuVisibility: 'inactive'
                },
            ],
            visibility: 'inactive'
        },

        {
            title: 'Groups',
            icon: 'accounts-alt',
            route: '/groups',
            role : [
                {
                    type : 4
                },
                {
                    type : 5
                }
            ]
        },
        {
            title: 'Settings',
            icon: 'settings',
            show : [
                {
                    type : 1
                }
            ],
            sub: [
                {
                    title: 'General',
                    icon: 'settings',
                    route: '/settings',
                    role : [
                        {
                            type : 1
                        },
                        {
                            type : 2
                        },
                        {
                            type : 4
                        },
                        {
                            type : 8
                        }
                    ],
                },
                /*{
                    title: 'Manage Recipient',
                    icon: 'accounts-alt',
                    route: '/manage-recipient',
                    role:[
                        {
                            type : 4
                        },
                        {
                            type : 5
                        }
                    ]
                },*/
               /* {
                    title: 'Company Access Limit',
                    route: '/company-access-limit',
                    icon:'circle-o',
                    role : [
                        {
                            type : 5
                        },
                    ],
                },*/
                // {
                //     title: 'Users Group',
                //     icon: 'accounts-alt',
                //     route: '/home'
                // },
                // {
                //     title: 'Storage Cloud',
                //     icon:'storage',
                //     route: '/storage-cloud'
                // },
                // {
                //     title: 'Upload Document',
                //     icon:'upload',
                //     route: '/business-doc-signee',
                //     role:[
                //         {
                //             type : 4
                //         },
                //         {
                //             type : 5
                //         }
                //     ]
                // },
                // {
                //     title: 'Payments',
                //     icon :'money-box',
                //     subMenu : [
                //         {
                //             title : 'Payment Method',
                //             route : '/home',
                //             icon:'grid'
                //         },
                //         {
                //             title : 'Payment Schedule',
                //             route : '/home',
                //             icon:'grid'
                //         },
                //         {
                //             title : 'Bank Account/CC',
                //             route : '/home',
                //             icon:'accounts-add'
                //         }
                //     ],
                //     subMenuVisibility: 'inactive'
                // },
                {
                    title: 'Logs',
                    icon:'view-list',
                    route: '/activity-log',
                   /*subMenu : [
                        {
                            title : 'Activity',
                            route : '/activity-log',
                            icon:'circle-o'
                        },
                        {
                            title : 'Request',
                            route : '/request-log',
                            icon:'circle-o'
                        },
                        {
                          title : 'PostMapping',
                          route : '/postmapping-logs',
                          icon:'circle-o'
                        },
                        {
                            title : 'Storage',
                            route : '/storage-log',
                            icon:'circle-o'
                        },
                        {
                            title : 'API',
                            route : '/request-input-logs',
                            icon:'circle-o'
                        }
                    ],*/
                    role:[
                        {
                            type : 4
                        },
                        {
                            type : 5
                        }
                    ],
                    subMenuVisibility: 'inactive'
                },
                // {
                //     title: 'Custom Profile Field',
                //     icon:'grid',
                //     route: '/home',
                //     role:[
                //         {
                //             type: 4
                //         }
                //     ]
                // },
                // {
                //     title: 'Google Spreadsheet',
                //     icon:'grid',
                //     route: '/google-spreadsheet',
                //     role:[
                //         {
                //             type : 4
                //         },
                //         {
                //             type : 5
                //         }
                //     ]
                // },
                // {
                //   title: 'Payments',
                //   icon:'key',
                //   route: '/manage-cards',
                //   role:[
                //     {
                //         type : 4
                //     },
                //     {
                //         type : 5
                //     },
                //     {
                //         type : 6
                //     }
                //  ]
                // },
                {
                    title : 'Slack',
                    route: '/slack',
                    icon:'settings',
                    role:[
                        {
                            type : 6
                        }
                     ]
                },
		        {
                  title: 'Plans',
                  icon: 'grid',
                  route: '/plans',
                  role : [
                    {
                      type : 4
                    },
		    {
                      type : 5
                    },
		    {
                      type : 6
                    },
                    // {
                    //   type : 8
                    // }
                 ]
                },
		            {
                  title: 'Products',
                  icon: 'grid',
                  route: '/manage-product',
                  role:[
                    {
                      type : 4
                    }
                  ]
                },
                {
                  title: 'Email Templates',
                  icon: 'grid',
                  route: '/email-template',
                  role:[
                    {
                      type : 4
                    },
                    {
                      type : 5
                    }
                  ]
                },
                /*{
                  title: 'Discounts',
                  icon: 'grid',
                  route: '/coupons',
                  role : [
                    {
                      type : 4
                    }
                  ]
                },*/
		          /*{
                  title: 'Manage Bank Account',
                  icon:'key',
                  route: '/manage-bank-accounts',
                  role:[
                    {
                        type : 4
                    },
                    {
                        type : 5
                    },
                    {
                        type : 6
                    }
                 ]
                },
                {
                  title : 'Younium Tool',
                  route : '/younium-tool',
                  icon:'settings',
                  role:[
                    {
                      type : 4
                    },
                    {
                      type : 5
                    }
                  ]
                },*/
                {
                  title : 'DealHub',
                  route : '/dealhub-config',
                  icon:'settings',
                  role:[
                    {
                      type : 4
                    }
                    /*,
                    {
                      type : 5
                    }*/
                  ]
                },
                {
                    title: 'Integrations',
                    icon:'settings',
                    subMenu : [
                      {
                          title : 'HubSpot',
                          route: '/hubspot-integration',
                          icon:'settings'
                      },
                      {
                        title : 'Younium',
                        route: '/younium-tool',
                        icon:'settings',
                        role:[
                          {
                            type : 4
                          },
                          {
                            type : 5
                          }
                        ]
                      },
                      {
                        title: 'Younium Invoices',
                        route: '/invoice-listing',
                        icon:'view-list',
                        role : [
                            {
                                type : 4
                            }
                        ],
                      },
                      {
                        title : 'API Keys',
                        route : '/manage-keys',
                        icon:'key'
                      },
                      {
                        title : 'Slack',
                        route: '/slack',
                        icon:'settings'
                      },
                    ],
                    role:[
                        {
                            type : 4
                        },
                        {
                            type : 5
                        }
                    ],
                    subMenuVisibility: 'inactive'
                }
            ],
            visibility: 'inactive'
        },
        // {
        //     title: 'Buy Plan',
        //     icon: 'shopping-cart',
        //     route: '/logout',
        //     show : [
        //         {
        //             type : 1
        //         }
        //     ],
        // },
        {
            title: 'Email Templates',
            icon: 'grid',
            route: '/email-template',
            show : [
                {
                    type : 0
                }
            ],
        },
        /*{
          title: 'Company Plan',
          icon: 'grid',
          route: '/company-plan',
          show : [
              {
                  type : 0
              }
          ],
        },*/
        {
          title: 'Manage Company Plans',
          icon: 'grid',
          route: '/company-plan',
          show : [
              {
                  type : 0
              }
          ],
        },
	    {
          title: 'Products',
          icon: 'grid',
          route: '/manage-product',
          role:[
            {
              type : 0
            },
            {
              type : 1
            }
           ]
        },
        {
            title: 'License',
            icon: 'grid',
            route: '/manage-license',
            role:[
              {
                type : 0
              },
              {
                type : 1
              }
             ]
          },

        // {
        //    title: 'Slack',
        //    icon: 'grid',
        //    route: '/slack',
        //    show : [
        //      {
        //        type : 0
        //      }
        //    ],
        // },
        /*{
          title: 'Discounts',
          icon: 'grid',
          route: '/coupons',
          show : [
            {
              type : 0
            }
          ]
        },*/
        {
            title: 'Logout',
            icon: 'power',
            route: '/logout'
        },
    ];

    isActiveMenu:boolean=false;
    // Toggle sub menu
    toggleSubMenu(i) {
        this.mainMenu[i].visibility = (this.mainMenu[i].visibility === 'inactive' ? 'active' : 'inactive');
        console.log(this.mainMenu);
        if(this.mainMenu.length > 0){
          let anyactive:any = this.mainMenu.some((menuitem) => {
            if(typeof menuitem.visibility != 'undefined' && menuitem.visibility == 'active' && menuitem.title == 'Settings'){
              return true;
            }
          });
          if(anyactive){
            this.isActiveMenu = true;
          }else {
            this.isActiveMenu  = false;
          }
        }
    }

    // Toggle menu sub menu
    toggleMenuSubMenu(menu_index,subMenu_index) {
        this.mainMenu[menu_index].sub[subMenu_index].subMenuVisibility = (this.mainMenu[menu_index].sub[subMenu_index].subMenuVisibility === 'inactive' ? 'active' : 'inactive');
        console.log('sub menu is', this.mainMenu);
    }

    constructor( private cookieService: CookieService,private service: AppService,private ngZone: NgZone,
        private authService : AuthenticationService,private versionCheckService: VersionCheckService,public signService: SignImageService, private toaster : ToastrService,private router: Router, private userIdle: UserIdleService,private generalService : GeneralService,private encryptdecrypt: EncrDecrServiceService,private tokenStorageService: TokenStorageService) {
        this._accessToken = ConstantConfigService.accessToken;
        this._guestToken = ConstantConfigService.guestToken;
    }
    allowed_lifecycle:boolean=false;

    messageLinks: any[] = [
        {
            name: 'Personal Profile',
            route: '/edit-user',
        },
        {
            name: 'Company Profile',
            route: '/settings',
            role:[
                {
                    type : 4
                }
            ]
        },
        {
          name: 'Subscriptions and Billing',
          route: '/manage-subscriptions',
          role:[
              {
                  type : 4
              },
              {
                  type : 5
              }
          ]
        },
        {
            name: 'Users & Licenses',
            route: '/manage-user',
            role:[
                {
                    type : 1
                },
                {
                    type : 4
                },
                {
                    type : 5
                }
            ]
        },
        {
            name: 'Logout',
            route: '/logout',
        }
    ];
    full_name_user : string = "";
    role_name : string = "";
    is_licensed;
    younium_tool_access;
    ngOnInit() {
        const myToken = this.tokenStorageService.getValidToken();
        console.log('myToken',myToken);

        //const myToken = localStorage.getItem(this._accessToken);
        if (typeof myToken!="undefined" && myToken != "" && myToken!="undefined") {
            this.decodedToken = helper.decodeToken(myToken);
            if(typeof this.decodedToken!="undefined" && this.decodedToken!=null && this.decodedToken['userdata']!=null && typeof this.decodedToken['userdata']!="undefined" && typeof this.decodedToken['userdata']['beta_features']!="undefined"){
              this.full_name_user = this.decodedToken['userdata']['full_name'];
              this.role_name = this.decodedToken['userdata']['role_name'];

              this.is_licensed =  this.decodedToken['userdata']['is_licensed_user'];
              this.younium_tool_access =  this.decodedToken['userdata']['younium_tool_access'];
              let beta_features = this.decodedToken['userdata']['beta_features'];
              let enable_for_all_features = this.decodedToken['userdata']['enabled_features'];

              //this.allowed_lifecycle = this.signService.checkfeatureallowed(beta_features,enable_for_all_features,'LifeCycle Management');
            }
            //console.log('allowed_lifecycle', this.allowed_lifecycle);
        }

        //console.log('sidebar authenticated',this.authService.isAuthenticated());
        if (this.authService.isAuthenticated()){
          //console.log('inside refresh token function')
          this.versionCheckService.refreshTokens();
          if (typeof myToken!="undefined" && myToken != "" && myToken!="undefined") {
          //this.versionCheckService.refreshRequestTokens();
          }
        } else {
          //console.log('not authenticated');
        }

        //check for non activity by service
        if(this.authService.isAuthenticated()){
            this.encryptdecrypt.checkInActivity();
        }
    }
    getStyle(scrollTop){
        let style: any = {};
        style.bottom = '-'+scrollTop+'px';
        return style;
    }

    showStatus(val){

        if(this.decodedToken!=null && typeof this.decodedToken.userdata!="undefined"){
            if(val.show!=undefined){
                for (let i=0; i<val.show.length;i++){
                    if(val.show[i].type==this.decodedToken.userdata.user_type){
                        return true;
                        break;
                    }
                }
            }
            else if(val.role!=undefined){
                for (let i=0; i<val.role.length;i++){
                    if(val.role[i].type==this.decodedToken.userdata.role_id){
                        if(val.route === '/younium-tool'){
                            if(this.is_licensed == 1 && this.younium_tool_access == 1){
                              return true;
                              break;
                            }
                        }else{
                            return true;
                            break;
                        }
                    }
                }
            }
            else{
                return true;
            }

        }

    }

    showStatusLeftBox(val,type){
        if(type=='Logout'){
            return false;
        }else{
            if(this.decodedToken!=null && typeof this.decodedToken.userdata!="undefined"){
                if(val.show!=undefined){
                    for (let i=0; i<val.show.length;i++){
                        if(val.show[i].type==this.decodedToken.userdata.user_type){
                            return true;
                            break;
                        }
                    }
                }
                else if(val.role!=undefined){
                    for (let i=0; i<val.role.length;i++){
                        if(val.role[i].type==this.decodedToken.userdata.role_id){
                            // if(val.route === '/deal-listing'){
                            //     if(this.allowed_lifecycle){
                            //       return true;
                            //       break;
                            //     }
                            // }else{
                                return true;
                                break;
                            //}

                        }
                    }
                }
                else{
                    return true;
                }

            }
        }
    }

    showLogut(val,type){
        if(type=='Logout'){
            return false;
        }else{
            return true;
        }
    }
    _guestToken;
    logout(){
        this.authService.logout();
        this.router.navigate(['/login']);
        //this.authService.logout();
    }

    message_box_show:boolean = true;
    hideBox(){
        this.message_box_show = !this.message_box_show;
    }

}
